import { gql } from '@apollo/client'

export const CHECKOUT_SESSION_TYPE_FRAGMENT = gql`
  fragment CheckoutSessionType on CheckoutSessionType {
    id
    clientSecret
  }
`
